import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome, FiUsers, FiAward, FiHeart } from 'react-icons/fi';

const About = () => {
  const styles = {
    hero: {
      background: 'linear-gradient(rgba(26,58,92,0.7), rgba(26,58,92,0.8)), url("/images/about-hero.jpg") center/cover',
      padding: '100px 24px',
      textAlign: 'center',
      color: 'white'
    },
    title: { fontSize: '3rem', fontWeight: '700', marginBottom: '16px', color: 'white', textShadow: '0 2px 4px rgba(0,0,0,0.3)' },
    subtitle: { fontSize: '1.25rem', color: 'white', maxWidth: '600px', margin: '0 auto', textShadow: '0 1px 2px rgba(0,0,0,0.2)' },
    section: { padding: '80px 24px' },
    container: { maxWidth: '1000px', margin: '0 auto' },
    content: { fontSize: '1.125rem', lineHeight: '1.8', color: '#333' },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '24px',
      marginTop: '60px'
    },
    stat: { textAlign: 'center' },
    statNumber: { fontSize: '3rem', fontWeight: '700', color: '#1a3a5c' },
    statLabel: { color: '#555', marginTop: '8px' },
    valuesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '32px',
      marginTop: '40px'
    },
    valueCard: {
      padding: '32px',
      background: '#f7f7f7',
      borderRadius: '16px'
    },
    valueIcon: {
      width: '56px',
      height: '56px',
      background: '#1a3a5c',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '1.5rem',
      marginBottom: '16px'
    },
    valueTitle: { fontSize: '1.25rem', fontWeight: '600', marginBottom: '12px' },
    valueText: { color: '#555', lineHeight: '1.6' },
    cta: {
      background: '#222',
      padding: '60px 24px',
      textAlign: 'center',
      color: 'white'
    }
  };

  return (
    <>
      <header style={styles.hero}>
        <h1 style={styles.title}>About Kasbia Stays</h1>
        <p style={styles.subtitle}>
          Your home away from home. Premium serviced apartments across the UK.
        </p>
      </header>

      <section style={styles.section}>
        <div style={styles.container}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '24px', textAlign: 'center' }}>
            Our Story
          </h2>
          <div style={styles.content}>
            <p style={{ marginBottom: '20px' }}>
              Founded with a vision to redefine temporary accommodation, Kasbia Stays offers a curated collection of luxury serviced apartments designed for modern travelers, business professionals, and families seeking comfortable extended stays.
            </p>
            <p style={{ marginBottom: '20px' }}>
              We believe that a great stay should feel like home. That's why every Kasbia Stays apartment is thoughtfully designed with premium furnishings, fully-equipped kitchens, high-speed WiFi, and all the amenities you need for a productive and relaxing stay.
            </p>
            <p>
              Whether you're relocating for work, traveling for business, or simply exploring a new city, Kasbia Stays provides the perfect blend of hotel-like service with the comfort and privacy of your own apartment.
            </p>
          </div>

          <div style={styles.statsGrid} className="stats-grid">
            <div style={styles.stat}>
              <div style={styles.statNumber}>50+</div>
              <div style={styles.statLabel}>Apartments</div>
            </div>
            <div style={styles.stat}>
              <div style={styles.statNumber}>10+</div>
              <div style={styles.statLabel}>Locations</div>
            </div>
            <div style={styles.stat}>
              <div style={styles.statNumber}>5000+</div>
              <div style={styles.statLabel}>Happy Guests</div>
            </div>
            <div style={styles.stat}>
              <div style={styles.statNumber}>4.8</div>
              <div style={styles.statLabel}>Average Rating</div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ ...styles.section, background: '#f7f7f7' }}>
        <div style={styles.container}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '16px', textAlign: 'center' }}>
            Our Values
          </h2>
          <p style={{ textAlign: 'center', color: '#555', marginBottom: '40px' }}>
            What makes Kasbia Stays different
          </p>

          <div style={styles.valuesGrid} className="values-grid">
            <div style={styles.valueCard}>
              <div style={styles.valueIcon}><FiHome /></div>
              <h3 style={styles.valueTitle}>Quality First</h3>
              <p style={styles.valueText}>
                Every apartment is carefully vetted and maintained to the highest standards of comfort and cleanliness.
              </p>
            </div>
            <div style={styles.valueCard}>
              <div style={styles.valueIcon}><FiUsers /></div>
              <h3 style={styles.valueTitle}>Guest-Centric</h3>
              <p style={styles.valueText}>
                Our dedicated support team is available 24/7 to ensure your stay exceeds expectations.
              </p>
            </div>
            <div style={styles.valueCard}>
              <div style={styles.valueIcon}><FiAward /></div>
              <h3 style={styles.valueTitle}>Trust & Safety</h3>
              <p style={styles.valueText}>
                Secure bookings, verified properties, and transparent pricing you can rely on.
              </p>
            </div>
            <div style={styles.valueCard}>
              <div style={styles.valueIcon}><FiHeart /></div>
              <h3 style={styles.valueTitle}>Local Experience</h3>
              <p style={styles.valueText}>
                Our apartments are located in prime areas, giving you the best local experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section style={styles.cta}>
        <div style={styles.container}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '16px' }}>
            Ready to Experience Kasbia Stays?
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '24px' }}>
            Browse our apartments and find your perfect stay
          </p>
          <Link to="/apartments" style={{
            display: 'inline-block',
            background: '#1a3a5c',
            color: 'white',
            padding: '14px 32px',
            borderRadius: '8px',
            fontWeight: '600',
            textDecoration: 'none'
          }}>
            View Apartments
          </Link>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .stats-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .values-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </>
  );
};

export default About;
